export const SuccessMessageConst = {
  ItemDeletedSuccessfully: 'Servicio eliminado exitosamente',
  ItemAddedSuccessfully: 'Servicio agregado exitosamente',

  MultipleDomainAddedSuccessfully: 'Dominio agregados exitosamente',
  DomainAddedSuccessfully: 'Dominio agregado exitosamente',

  ContactAddedSuccessfully: "La información del contacto se almacenó exitosamente"

};
